<template>
  <div style="padding-top: -2px; margin-top: -2px">
    <template v-if="check == false && radio == false && checkList == false && multiple == false">
      <v-label>
        <b>{{ labelComputed }}</b>
      </v-label>
      <s-select-generic ref="sgeneric" :autocomplete="searchable" full style="margin-top: 0px" :config="config"
        :disabled="disabled" :readonly="readonly" :itemvalue="id" :add="add || isCustomAdd" :clearable="clearable"
        :itemtext="abbr ? 'DedAbbreviation' : 'DedDescription'" @add="addEvent()" :id="id" :noDefault="clearable"
        :value="valueLocal" @input="input($event)" @change="change($event)" :returnObject="returnObject"
        :autofocus="autofocus" @updateData="onGenericUpdateData($event)" />
    </template>

    <div v-if="check">
      <v-label>
        <b>{{ labelComputed }}</b>
      </v-label>
      <v-checkbox hide-details="" v-for="(item, i) in items" :value="item[id]" :disabled="disabled" :readonly="readonly"
        v-model="selected" :label="abbr ? item.DedAbbreviation : item.DedDescription" :key="i" />
    </div>

    <v-radio-group v-if="radio" :row="row" v-model="valueRadio" :mandatory="false" hide-details :disabled="disabled"
      :readonly="readonly">
      <v-radio v-for="(item, i) in items" :label="item.DedDescription" :value="item[id]" :key="i"></v-radio>
    </v-radio-group>

    <div v-if="checkList || multiple">
      <v-autocomplete class="sselect-definition__select hide-selected-chips" multiple v-model="selected" :items="items"
        :item-text="abbr ? 'DedAbbreviation' : 'DedDescription'" :item-value="id" :return-object="returnObject"
        :label="labelComputed" :clearable="clearable" :disabled="disabled" :readonly="readonly" hide-details
        :search-input.sync="searchQuery" @change="clearSearch">
        <template v-slot:selection="{ item, index }">
          <template v-if="badgesBelow">
            <span v-if="index < 1" class="text-body-2">
              {{ getSelectedLabel(item) }}
            </span>
            <span v-else-if="index === 1" class="ml-2 grey--text text--darken-1">
              +{{ selected.length - 1 }}
            </span>
          </template>

          <template v-else-if="list">
            <v-chip x-small class="ma-1" color="teal" label outlined close @click:close="selected.splice(index, 1)">
              {{ getSelectedLabel(item) }}
            </v-chip>
          </template>

          <template v-else>
            <v-chip v-if="index < 1" x-small class="ma-1" color="teal" label outlined>
              {{ getSelectedLabel(item) }}
            </v-chip>
            <span v-else-if="index === 1" class="ml-2 grey--text text--darken-1">
              +{{ selected.length - 1 }}
            </span>
          </template>
        </template>
      </v-autocomplete>

      <div v-if="badgesBelow && selected && selected.length" class="sselect-definition__badges mt-1">
        <template v-for="(val, i) in selected">
          <v-chip v-if="getSelectedItem(val)" :key="getSelectedKey(val, i)" x-small class="ma-1" color="teal" label
            outlined close @click:close="removeSelectedAt(i)">
            {{ getSelectedLabel(val) }}
          </v-chip>
        </template>
      </div>
      <div v-if="add || isCustomAdd" class="mt-1">
        <v-btn x-small text color="primary" @click="addEvent()">
          <v-icon left x-small>mdi-plus</v-icon>
          Gestionar opciones
        </v-btn>
      </div>
    </div>

    <v-dialog light style="border-radius: 0px !important" v-model="dialogAdd" v-if="dialogAdd" width="700">
      <v-card>
        <v-toolbar dark flat dense elevation="0" color="primary">
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="dialogAdd = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-divider></v-divider>
        <v-col style="padding-top: 0px"><definition-detail @refresh="refresh($event)" :defID="def"
            :customAdd="isCustomAdd" :customFields="customFields"></definition-detail></v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sDefinition from "@/services/General/DefinitionService.js";
import DefinitionDetail from "@/views/General/Definition/DefinitionDetail";

export default {
  components: { DefinitionDetail },
  props: {
    id: {
      type: String,
      default: "DedValue",
    },
    abbr: {
      type: Boolean,
      default: false,
    },
    value: null,
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    def: {
      type: Number,
      default: 0,
    },
    add: {
      type: Boolean,
      default: false,
    },
    customAdd: {
      type: Boolean,
      default: false,
    },
    addCustom: {
      type: Boolean,
      default: false,
    },
    customFields: {
      type: Array,
      default: () => [],
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Boolean,
      default: false,
    },
    radio: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
    dgr: {
      type: Number,
      default: 0,
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    checkList: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    list: {
      type: Boolean,
      default: false,
    },
    badgesBelow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    valueRadio: null,
    selected: [],
    valueLocal: null,
    dialogAdd: false,
    item: 0,
    items: [],
    searchQuery: null,
    config: {
      url: _sDefinition.definitiongroupURL(),
      title: "",
      params: {
        defID: 0,
        dgrID: 0,
        requestID: 0,
      },
    },
  }),

  watch: {
    dgr() {
      this.config.params.dgrID = this.dgr;
    },

    def() {
      this.config.params.defID = this.def;
    },

    // 🔧 WATCHER MEJORADO PARA SELECTED
    selected: {
      handler(newValue) {
        if (this.multiple || this.checkList || this.check) {
          //console.log("Selected changed:", newValue);
          this.emitMultipleValue(newValue);
        } else {
          // Para selección única
          let foundItem = this.items.find((x) => x[this.id] == newValue);
          if (!this.returnObject) {
            this.$emit("input", newValue);
          } else {
            this.$emit("input", foundItem);
          }
        }
      },
      deep: true, // 🔑 Importante para detectar cambios en arrays
      immediate: false,
    },

    valueRadio(value) {
      this.$emit("input", value);
      this.$emit(
        "returnObject",
        this.items.find((x) => x[this.id] == value)
      );
    },

    // 🔧 WATCHER MEJORADO PARA VALUE
    value: {
      handler(newValue) {
        //console.log("Value prop changed:", newValue);
        this.updateInternalValue(newValue);
      },
      immediate: true,
    },
    dialogAdd(newValue) {
      if (newValue === false) {
        this.refresh();
      }
    },
  },

  methods: {
    clearSearch() {
      this.$nextTick(() => {
        this.searchQuery = null;
      });
    },
    error(msg) {
      if (this.check || this.radio || this.checkList || this.multiple) {
        this.$fun.alert(msg, "warning");
      } else {
        let refGeneric = Array.isArray(this.$refs.sgeneric) ? this.$refs.sgeneric[0] : this.$refs.sgeneric;
        if (refGeneric && typeof refGeneric.error === 'function') {
          refGeneric.error(msg);
        } else {
          this.$fun.alert(msg, "warning");
        }
      }
    },
    isFocused(val) {
      this.$refs.sgeneric.isFocused(val);
    },

    onGenericUpdateData(data) {
      this.items = data || [];
      this.$emit("updateData", this.items);
    },

    refresh(item) {
      this.$http
        .post(
          _sDefinition.definitiongroupURL(),
          {},
          { params: this.config.params }
        )
        .then((r) => {
          if (r.status == 200) {
            this.items = r.data;
            this.$emit("updateData", this.items);
          }
        });

      if (!this.multiple && !this.checkList && !this.check) {
        const ref = Array.isArray(this.$refs.sgeneric)
          ? this.$refs.sgeneric[0]
          : this.$refs.sgeneric;
        if (ref && typeof ref.load === "function") ref.load();
      }
    },

    addEvent() {
      this.dialogAdd = true;
    },

    input(item) {
      this.$emit("input", item);
    },

    change(item) {
      this.$emit("change", item);
    },

    emitMultipleValue(value) {
      if (!this.returnObject) {
        // Emitir como JSON string para compatibilidad
        const stringValue = JSON.stringify(value);
        this.$emit("input", stringValue);
      } else {
        // Emitir objetos completos (soporta arrays de IDs o de objetos)
        const objectsValue = (Array.isArray(value) ? value : [])
          .map((val) => {
            if (val && typeof val === "object") return val;
            return this.items.find((item) => item[this.id] === val);
          })
          .filter(Boolean);
        this.$emit("input", objectsValue);
      }
    },

    getSelectedItem(val) {
      if (val && typeof val === "object") return val;
      return this.items.find((x) => x && x[this.id] === val) || null;
    },

    getSelectedLabel(val) {
      const obj = this.getSelectedItem(val);
      if (!obj) return String(val ?? "");
      return this.abbr ? obj.DedAbbreviation : obj.DedDescription;
    },

    getSelectedKey(val, index) {
      const obj = this.getSelectedItem(val);
      if (obj && obj[this.id] !== undefined && obj[this.id] !== null) return obj[this.id];
      return `${index}-${String(val)}`;
    },

    removeSelectedAt(index) {
      this.selected.splice(index, 1);
    },

    updateInternalValue(value) {
      if (this.radio) {
        this.valueRadio = value;
      } else if (this.check || this.multiple || this.checkList) {
        if (value === null || value === undefined) {
          this.selected = [];
        } else if (typeof value === "string") {
          try {
            const parsed = JSON.parse(value);
            this.selected = Array.isArray(parsed)
              ? parsed
              : value.split(",").map((v) => {
                const num = Number(v);
                return isNaN(num) ? v : num;
              });
          } catch {
            this.selected = value.split(",").map((v) => {
              const num = Number(v);
              return isNaN(num) ? v : num;
            });
          }
        } else if (Array.isArray(value)) {
          this.selected = [...value]; // Crear una copia para evitar mutaciones
        } else {
          this.selected = [value];
        }
      } else {
        if (value !== null && value !== undefined && value !== "" && Array.isArray(this.items) && this.items.length > 0) {
          const valStr = String(value).trim().toLowerCase();
          const found = this.items.find(x => 
            String(x[this.id]).trim().toLowerCase() === valStr || 
            String(x.DedValue).trim().toLowerCase() === valStr || 
            String(x.DedDescription).trim().toLowerCase() === valStr || 
            (x.DedID && String(x.DedID).trim().toLowerCase() === valStr)
          );
          if (found) {
            this.valueLocal = (found[this.id] !== undefined && found[this.id] !== null) ? found[this.id] : found.DedDescription;
          } else {
            this.valueLocal = value;
          }
        } else {
          this.valueLocal = value;
        }
      }
    },
    focus() {
      const g = this.$refs.sgeneric;
      if (g && typeof g.focus === "function") {
        g.focus();
      }
    },
    error(msg) {
      const g = this.$refs.sgeneric;
      if (g && typeof g.error === "function") {
        g.error(msg);
      }
    },
  },

  created() {
    this.config.title = this.label;
    this.config.params.defID = this.def;
    this.config.params.dgrID = this.dgr;
    this.config.params.requestID = this.$fun.getUserID();

    // 🔧 INICIALIZAR VALOR DESPUÉS DE CARGAR DATOS
    this.$http
      .post(
        _sDefinition.definitiongroupURL(),
        {},
        { params: this.config.params }
      )
      .then((r) => {
        if (r.status == 200) {
          this.items = r.data;
          this.$emit("getDataInitial", this.items);

          // 🔑 Inicializar valor después de cargar items
          this.updateInternalValue(this.value);

          // 🧠 NUEVO: si el valor es un id válido y returnObject está activo,
          // busca el objeto correspondiente y actualiza el valor local.
          if (this.returnObject && this.value !== null && this.value !== undefined && typeof this.value !== "object") {
            const found = this.items.find(x => String(x[this.id]) === String(this.value));
            if (found) {
              this.valueLocal = found;
              this.$emit("input", found);
            }
          }
        }
      });
  },

  computed: {
    isCustomAdd() {
      return this.customAdd || this.addCustom || this.addCuston;
    },
    labelComputed() {
      if (this.showLabel == false) return "";
      if (this.label) return this.label;
      if (this.items.length > 0 && this.items[0].DefDescription) {
        return this.items[0].DefDescription;
      }
      return "";
    },
  },
};
</script>

<style scoped>
::v-deep .sselect-definition__select .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}

/* 🆕 Oculta por completo los chips/textos seleccionados dentro del input principal */
::v-deep .hide-selected-chips .v-select__selections .v-chip,
::v-deep .hide-selected-chips .v-select__selections .text-body-2,
::v-deep .hide-selected-chips .v-select__selections span {
  display: none !important;
}
/* Mantiene el área del input más "limpia" cuando hay múltiples */
::v-deep .hide-selected-chips .v-select__selections input {
  display: inline-block !important;
}

/* Badges debajo: ordenados, envuelven y no rompen el layout */
.sselect-definition__badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: 96px;
  overflow: auto;
}
</style>
